// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/connections/firstparty/v2/common.proto

/* oxlint-disable */
import { ApiConnection } from "./connection";

/** The data wrapped by JSONAPI spec. */
export interface ApiResponseData {
  /** The unique identifier for the connection. */
  readonly id: string;
  /** The type of the resource */
  readonly type: string;
  /** The connection attributes. */
  readonly attributes: ApiConnection | null;
}

export const ApiResponseData: MessageFns<ApiResponseData> = {
  fromJSON(object: any): ApiResponseData {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      attributes: isSet(object.attributes) ? ApiConnection.fromJSON(object.attributes) : null,
    };
  },

  toJSON(message: ApiResponseData): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.type !== undefined && message.type !== null) {
      obj.type = message.type;
    }
    if (message.attributes !== undefined && message.attributes !== null) {
      obj.attributes = ApiConnection.toJSON(message.attributes);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
